<app-modal maxWidth="760px" maxHeight="88vh" bodyOverflow="auto">
  <div header class="flex items-center gap-2">
    <span class="text-base font-semibold text-slate-100">Send us a support case</span>
  </div>

  <div body class="p-4 sm:p-5">
    <app-feedback-form [allowMarkdownDnd]="true" (submitted)="onSubmitted()"></app-feedback-form>
  </div>
</app-modal>
